import UnitedStatesFlag from '../assets/images/flags/us.jpg';
import RussianFlag from '../assets/images/flags/ru.jpg';

export default {
	en: {
		title: 'Languages.en',
		icon: UnitedStatesFlag
	},
	ru: {
		title: 'Languages.ru',
		icon: RussianFlag
	}
};
